(function(){"use strict";
  /** @type {HTMLElement|null} */
  const section = (document.currentScript && /** @type {HTMLElement} */(document.currentScript).closest('[data-section-id]')) || document.querySelector('[data-section-id]');
  const root = section || document;
  const cats = root.querySelector('[data-om-cats]');
  const menu = root.querySelector('[data-om-menu]');
  const cartEl = root.querySelector('[data-om-cart]');

  /** @param {string} sel @param {ParentNode=} ctx */
  function $(sel, ctx){ return (ctx||document).querySelector(sel); }
  /** @param {string} sel @param {ParentNode=} ctx */
  function $all(sel, ctx){ return Array.from((ctx||document).querySelectorAll(sel)); }

  /** @param {EventTarget|null} el @param {string} ev @param {(e: any)=>void} fn */
  function on(el, ev, fn){ el && /** @type {Element} */(el).addEventListener(ev, fn, { passive: true }); }

  // Parse global add-on collections (fallback)
  const EXTRAS_JSON = $('[data-extras-json]');
  const SAUCES_JSON = $('[data-sauces-json]');
  const GLOBAL_EXTRAS = EXTRAS_JSON ? JSON.parse(EXTRAS_JSON.textContent||'[]') : [];
  const GLOBAL_SAUCES = SAUCES_JSON ? JSON.parse(SAUCES_JSON.textContent||'[]') : [];

  /** @param {HTMLElement} btn */
  function setActiveCat(btn){
    $all('.om__cat', cats||undefined).forEach(b=>b.removeAttribute('aria-current'));
    btn.setAttribute('aria-current','true');
  }

  /** @param {string} handle */
  function loadCollection(handle){
    if (!handle) return;
    $all('.om__list', menu||undefined).forEach(list=>{
      (/** @type {HTMLElement} */(list)).hidden = list.getAttribute('data-list') !== handle;
    });
  }

  /** @param {ParentNode} ctx */
  function bindCards(ctx){
    $all('.menu-card', ctx).forEach(card=>{
      const add = card.querySelector('[data-add]');
      const open = card.querySelector('[data-open-modal]');
      const hasOptions = card.getAttribute('data-has-options') === 'true';
      const hasGlobalOptions = (GLOBAL_EXTRAS.length + GLOBAL_SAUCES.length) > 0;
      const parentList = card.closest('.om__list');
      const listDisablesModal = !!(parentList && parentList.hasAttribute('data-disable-modal'));
      const wantsModal = !listDisablesModal && (hasOptions || hasGlobalOptions);
      on(card, 'click', (e)=>{ if ((/** @type {any} */(e)).target.closest('button')) return; wantsModal ? openModal(/** @type {HTMLElement} */(card)) : addDirect(/** @type {HTMLElement} */(card)); });
      on(add, 'click', (e)=>{ (/** @type {any} */(e)).stopPropagation(); wantsModal ? openModal(/** @type {HTMLElement} */(card)) : addDirect(/** @type {HTMLElement} */(card)); });
      on(open, 'click', (e)=>{ (/** @type {any} */(e)).preventDefault(); (/** @type {any} */(e)).stopPropagation(); wantsModal ? openModal(/** @type {HTMLElement} */(card)) : addDirect(/** @type {HTMLElement} */(card)); });
    });
  }

  /** @param {HTMLElement} card */
  function openModal(card){
    /** @type {HTMLDialogElement|null} */
    let dlg = document.querySelector('dialog[data-omodal]');
    if(!dlg){ console.warn('options modal not present'); return; }
    dlg.dataset.productId = card.getAttribute('data-product-id')||'';
    dlg.dataset.variantId = card.getAttribute('data-variant-id')||'';
    dlg.dataset.basePrice = card.getAttribute('data-base-price')||'0';
    dlg.dataset.handle = card.getAttribute('data-handle')||'';
    // Populate lists from global sets
    const extrasWrap = dlg.querySelector('[data-extras]');
    const saucesWrap = dlg.querySelector('[data-sauces]');
    if (extrasWrap){ extrasWrap.innerHTML = GLOBAL_EXTRAS.map(/** @param {{variant_id:number|string, price:number, title:string}} i */(i)=>{ return `<label class=\"opt\"><input type=\"checkbox\" data-extra data-id=\"${i.variant_id}\" data-price=\"${i.price}\"> ${i.title} <span class=\"price\">+${format(i.price)}</span></label>`; }).join(''); }
    if (saucesWrap){ saucesWrap.innerHTML = GLOBAL_SAUCES.map(/** @param {{variant_id:number|string, price:number, title:string}} i */(i)=>{ return `<label class=\"opt\"><input type=\"checkbox\" data-sauce data-id=\"${i.variant_id}\" data-price=\"${i.price}\"> ${i.title} <span class=\"price\">${i.price>0?('+'+format(i.price)):'FREE'}</span></label>`; }).join(''); }
    const stepExtras = dlg.querySelector('[data-step=\"extras\"]');
    const stepSauces = dlg.querySelector('[data-step=\"sauces\"]');
    stepSauces?.setAttribute('hidden','');
    stepExtras?.removeAttribute('hidden');
    const err = dlg.querySelector('[data-error-extras]'); if (err) /** @type {HTMLElement} */(err).style.display = 'none';
    const addB = /** @type {HTMLButtonElement|null} */ (dlg.querySelector('[data-add-to-cart]')); addB?.removeAttribute('disabled');
    bindModal(dlg);
    try { dlg.showModal(); } catch(e) { dlg.setAttribute('open',''); }
  }

  /** @param {number} cents */
  function format(cents){ return new Intl.NumberFormat(undefined, { style:'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format((Number(cents)||0)/100); }

  /** @param {HTMLDialogElement} dlg */
  function bindModal(dlg){
    const next = dlg.querySelector('[data-next]');
    const back = dlg.querySelector('[data-back]');
    const addBtn = /** @type {HTMLButtonElement|null} */ (dlg.querySelector('[data-add-to-cart]'));
    const totalEls = $all('[data-total]', dlg);
    const errorExtras = /** @type {HTMLElement|null} */ (dlg.querySelector('[data-error-extras]'));
    const stepExtras = /** @type {HTMLElement|null} */ (dlg.querySelector('[data-step="extras"]'));
    const stepSauces = /** @type {HTMLElement|null} */ (dlg.querySelector('[data-step="sauces"]'));

    // Rebind-safe listeners: abort previous bindings before adding new ones
    /** @type {any} */
    const anyDlg = dlg;
    if (anyDlg._bindCtrl && typeof anyDlg._bindCtrl.abort === 'function') {
      try { anyDlg._bindCtrl.abort(); } catch(_) {}
    }
    const bindCtrl = new AbortController();
    anyDlg._bindCtrl = bindCtrl;

    function basePrice(){ return parseInt(dlg.dataset.basePrice||'0',10)||0; }
    function selectedExtras(){ return $all('input[data-extra]:checked', dlg).map((el)=>({ id: el.getAttribute('data-id')||'', price: parseInt(el.getAttribute('data-price')||'0',10)||0 })); }
    function selectedSauces(){ return $all('input[data-sauce]:checked', dlg).map((el)=>({ id: el.getAttribute('data-id')||'', price: parseInt(el.getAttribute('data-price')||'0',10)||0 })); }

    async function resolveVariantId(){
      var vid = dlg.dataset.variantId||'';
      if (vid && vid !== 'null' && vid !== 'undefined') return vid;
      var handle = dlg.dataset.handle||'';
      if (!handle) return '';
      try {
        const res = await fetch('/products/'+encodeURIComponent(handle)+'.js', { credentials:'same-origin', headers:{'Accept':'application/json'} });
        const data = await res.json();
        if (data && data.variants && data.variants.length) return String(data.variants[0].id||'');
      } catch(e){ console.warn('resolveVariantId failed', e); }
      return '';
    }

    function updateTotal(){
      const sumExtras = selectedExtras().reduce((a,b)=>a+(b.price||0),0);
      const sumSauces = selectedSauces().reduce((a,b)=>a+(b.price||0),0);
      const total = (basePrice()+sumExtras+sumSauces);
      totalEls.forEach(el=>el.textContent = format(total));
    }

    dlg.addEventListener('input', updateTotal, { signal: bindCtrl.signal });
    dlg.addEventListener('change', updateTotal, { signal: bindCtrl.signal });
    updateTotal();

    // Extras toggles (no required selection, optional)
    dlg.querySelectorAll('input[data-extra]').forEach(el=>{
      el.addEventListener('change', ()=>{ if (errorExtras) errorExtras.style.display = 'none'; updateTotal(); }, { signal: bindCtrl.signal });
    });

    next && next.addEventListener('click', (e)=>{ (/** @type {any} */(e)).preventDefault();
      // Optional step: proceed regardless of selection
      if (errorExtras) errorExtras.style.display = 'none';
      stepExtras?.setAttribute('hidden','');
      stepSauces?.removeAttribute('hidden');
      updateTotal();
    }, { signal: bindCtrl.signal });
    back && back.addEventListener('click', (e)=>{ (/** @type {any} */(e)).preventDefault();
      stepSauces?.setAttribute('hidden','');
      stepExtras?.removeAttribute('hidden');
    }, { signal: bindCtrl.signal });

    addBtn && addBtn.addEventListener('click', async (e)=>{ (/** @type {any} */(e)).preventDefault();
      const bundleId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now())+Math.random().toString(16).slice(2);
      const vidRaw = await resolveVariantId();
      const vidNum = vidRaw ? Number(vidRaw) : 0;
      const extras = selectedExtras();
      const sauces = selectedSauces();
      const extrasNames = $all('input[data-extra]:checked', dlg).map(el=>el.parentElement?.textContent?.trim().replace(/\s+\+.*$/,'')||'').filter(Boolean).join(', ');
      const saucesNames = $all('input[data-sauce]:checked', dlg).map(el=>el.parentElement?.textContent?.trim().replace(/\s+\+.*$/,'')||'').filter(Boolean).join(', ');
      const btn = /** @type {HTMLButtonElement} */ (addBtn);
      btn.setAttribute('disabled','true');
      try {
        // Always sequential for reliability across preview domains
        if (vidNum) {
          const parentPayload = { id: String(vidNum), quantity: 1, properties: { _bundleId: bundleId, Extras: extrasNames, Sauces: saucesNames } };
          const r0 = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, credentials:'same-origin', body: JSON.stringify(parentPayload) });
          if (!r0.ok) console.warn('Parent add failed', await r0.text());
        }
        for (const i of extras){
          const idStr = String(i.id);
          if (!idStr) continue;
          const payload = { id: idStr, quantity: 1, properties: { _bundleId: bundleId, _isAddon: 'true' } };
          const r = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, credentials:'same-origin', body: JSON.stringify(payload) });
          if (!r.ok) console.warn('Addon add failed', await r.text());
        }
        for (const i of sauces){
          const idStr = String(i.id);
          if (!idStr) continue;
          const payload = { id: idStr, quantity: 1, properties: { _bundleId: bundleId, _isAddon: 'true' } };
          const r = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, credentials:'same-origin', body: JSON.stringify(payload) });
          if (!r.ok) console.warn('Sauce add failed', await r.text());
        }
      } catch(err){ console.warn(err); }
      finally {
        btn.removeAttribute('disabled');
      }
      try { (/** @type {any} */(dlg)).close(); } catch(_) { dlg.removeAttribute('open'); }
      refreshCart(true);
    }, { signal: bindCtrl.signal });
  }

  /** @param {HTMLElement} card */
  async function addDirect(card){
    const productId = card.getAttribute('data-product-id');
    const variantId = card.getAttribute('data-variant-id');
    const id = variantId || productId;
    if(!id) return;
    await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, credentials:'same-origin', body: JSON.stringify({ id, quantity: 1 }) });
    refreshCart(true);
  }

  /** @param {string} s */
  function escapeHtml(s){
    var str = String(s||'');
    return str.replace(/[&<>"']/g, function(m){
      switch(m){
        case '&': return '&amp;';
        case '<': return '&lt;';
        case '>': return '&gt;';
        case '"': return '&quot;';
        case "'": return '&#39;';
        default: return '';
      }
    });
  }

  /** @param {number} ms */
  function sleep(ms){ return new Promise(function(resolve){ setTimeout(resolve, ms); }); }

  /** @param {any} cartObj */
  function renderCartItems(cartObj){
    const container = root.querySelector('[data-cart-items]');
    if(!container) return;
    const items = Array.isArray(cartObj.items) ? cartObj.items : [];
    if(items.length === 0){
      container.innerHTML = '<p class="side-cart__empty">Количката ви е празна.</p>';
      return;
    }
    const html = items.map(function(/** @type {any} */ it, /** @type {number} */ idx){
      const isAddon = it.properties && it.properties._isAddon;
      const bundle = (it.properties && it.properties._bundleId) || '';
      const title = escapeHtml(it.product_title) + ((it.variant_title && it.variant_title !== 'Default Title') ? ' – ' + escapeHtml(it.variant_title) : '');
      const img = it.image ? `<img src="${it.image}" width="64" height="64" alt="${escapeHtml(it.product_title)}" loading="lazy">` : '';
      const extras = it.properties && it.properties.Extras ? `<div class="side-cart__prop">Добавки: ${escapeHtml(it.properties.Extras)}</div>` : '';
      const sauces = it.properties && it.properties.Sauces ? `<div class="side-cart__prop">Сосчета: ${escapeHtml(it.properties.Sauces)}</div>` : '';
      const props = (extras || sauces) ? `<div class="side-cart__props">${extras}${sauces}</div>` : '';
      const linePrice = format(it.final_line_price);
      return `<div class="side-cart__item ${isAddon ? 'is-addon' : ''}" data-line="${idx+1}" data-bundle="${bundle}">
        <div class="side-cart__media">${img}</div>
        <div class="side-cart__info">
          <div class="side-cart__row">
            <div class="side-cart__name">${title}</div>
            <div class="side-cart__price">${linePrice}</div>
          </div>
          ${props}
          <div class="side-cart__qty">
            <button data-decr aria-label="Decrease">−</button>
            <input type="number" min="0" value="${it.quantity}" data-qty>
            <button data-incr aria-label="Increase">+</button>
          </div>
        </div>
      </div>`;
    }).join('');
    container.innerHTML = html;
  }

  /** @param {boolean=} openAfter */
  async function refreshCart(openAfter){
    try {
      const res = await fetch('/cart.js', { credentials:'same-origin' });
      const cart = await res.json();
      const subtotal = new Intl.NumberFormat(undefined, { style:'currency', currency: cart.currency || 'USD' }).format(cart.items_subtotal_price/100);
      const subtotalEl = cartEl && cartEl.querySelector('.side-cart__subtotal strong');
      const barSubtotal = root.querySelector('[data-cart-bar-subtotal]');
      if (subtotalEl) subtotalEl.textContent = subtotal;
      if (barSubtotal) barSubtotal.textContent = subtotal;
      const itemsWrap = root.querySelector('[data-cart-items]');
      if (itemsWrap) renderCartItems(cart);
      if (openAfter && section) {
        section.setAttribute('data-cart-opened','true');
        // ensure into view
        const bar = root.querySelector('[data-cart-bar]');
        bar && bar.scrollIntoView({ block: 'end' });
      }
    } catch(e){ console.warn(e); }
  }

  /** @param {number} line @param {number} quantity */
  async function changeLineQuantity(line, quantity){
    if (!line || quantity < 0) return;
    try {
      await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        credentials:'same-origin',
        body: JSON.stringify({ line, quantity })
      });
    } catch(e){ console.warn(e); }
    await refreshCart(true);
  }

  // Category click
  on(cats, 'click', (e)=>{
    const btn = (/** @type {any} */(e)).target.closest('.om__cat');
    if(!btn) return;
    setActiveCat(btn);
    loadCollection(btn.getAttribute('data-collection-handle'));
  });

  // Search
  const search = root.querySelector('[data-om-search]');
  if (search){
    /** @type {number|undefined} */
    let t;
    on(search, 'input', ()=>{ if (t) clearTimeout(t); t = window.setTimeout(()=>{
      const q = (/** @type {HTMLInputElement} */(search)).value.trim().toLowerCase();
      $all('.om__list:not([hidden]) .menu-card', menu||undefined).forEach(card=>{
        const txt = (card.querySelector('.menu-card__title')?.textContent||'').toLowerCase();
        (/** @type {HTMLElement} */(card)).style.display = !q || txt.includes(q) ? '' : 'none';
      });
    }, 120); });
  }

  // Side cart quantity controls (event delegation)
  on(cartEl, 'click', (e)=>{
    const target = /** @type {any} */(e).target;
    if (!target) return;
    const incr = target.closest('[data-incr]');
    const decr = target.closest('[data-decr]');
    if (!incr && !decr) return;
    const item = target.closest('.side-cart__item');
    if (!item) return;
    const line = parseInt(item.getAttribute('data-line')||'0', 10) || 0;
    const input = /** @type {HTMLInputElement|null} */(item.querySelector('[data-qty]'));
    let qty = input ? (parseInt(input.value||'0',10) || 0) : 0;
    if (incr) qty += 1; else qty = Math.max(0, qty - 1);
    changeLineQuantity(line, qty);
  });

  on(cartEl, 'change', (e)=>{
    const input = /** @type {any} */(e).target?.closest('[data-qty]');
    if (!input) return;
    const item = input.closest('.side-cart__item');
    if (!item) return;
    const line = parseInt(item.getAttribute('data-line')||'0', 10) || 0;
    const qty = Math.max(0, parseInt(input.value||'0',10) || 0);
    changeLineQuantity(line, qty);
  });

  // Mobile cart open/close
  const openBtn = root.querySelector('[data-cart-open]');
  const closeBtn = root.querySelector('[data-cart-close]');
  on(openBtn, 'click', ()=>{ section && section.setAttribute('data-cart-opened','true'); });
  on(closeBtn, 'click', ()=>{ section && section.removeAttribute('data-cart-opened'); });

  // Checkout note modal
  const checkoutBtn = root.querySelector('[data-checkout-trigger]');
  /** @type {HTMLElement|null} */
  let noteModal = /** @type {HTMLElement|null} */ (root.querySelector('[data-note-modal]'));
  /** @type {HTMLTextAreaElement|null} */
  const noteInput = /** @type {HTMLTextAreaElement|null} */ (root.querySelector('[data-note-input]'));
  /** @type {HTMLButtonElement|null} */
  const noteCancel = /** @type {HTMLButtonElement|null} */ (root.querySelector('[data-note-cancel]'));
  /** @type {HTMLButtonElement|null} */
  const noteSubmit = /** @type {HTMLButtonElement|null} */ (root.querySelector('[data-note-submit]'));
  const closedMsg = root.querySelector('[data-closed-msg]');

  // Move modal to body to avoid stacking/transform issues
  if (noteModal && noteModal.parentElement !== document.body) {
    document.body.appendChild(noteModal);
  }

  // Hours live in assets/store-hours.js — never cache the result, a page can
  // sit open across the cutoff.
  const CLOSED_MESSAGE = 'Поръчките са затворени, защото не работим. Отваряме 11 сутрин.';

  function closedMessage(){
    return window.StoreHours && window.StoreHours.closedMessage
      ? window.StoreHours.closedMessage()
      : CLOSED_MESSAGE;
  }

  function isClosed(){
    return window.StoreHours ? window.StoreHours.isClosed() : false;
  }

  function showClosedPopup(){
    if (window.StoreHours && window.StoreHours.showClosedPopup) window.StoreHours.showClosedPopup();
    else alert(closedMessage());
  }

  function applyClosedState(){
    if (isClosed()) {
      // aria-disabled, not disabled — the click must still reach
      // store-hours.js so it can show the closed popup.
      checkoutBtn && checkoutBtn.setAttribute('aria-disabled','true');
      noteSubmit && noteSubmit.setAttribute('aria-disabled','true');
      if (closedMsg) closedMsg.textContent = closedMessage();
      closedMsg && closedMsg.removeAttribute('hidden');
      closedMsg && closedMsg.classList.add('is-visible');
    } else {
      checkoutBtn && checkoutBtn.removeAttribute('aria-disabled');
      noteSubmit && noteSubmit.removeAttribute('aria-disabled');
      closedMsg && closedMsg.setAttribute('hidden','');
      closedMsg && closedMsg.classList.remove('is-visible');
    }
  }

  function showNoteModal(){
    if (isClosed()) {
      applyClosedState();
      showClosedPopup();
      return;
    }
    if (!noteModal) { window.location.href = '/checkout'; return; }
    noteModal.hidden = false;
    noteModal.classList.add('is-open');
    noteModal.style.display = 'grid';
    document.body.classList.add('om-note-open');
    if (noteInput) noteInput.focus();
  }

  function hideNoteModal(){
    if (!noteModal) return;
    noteModal.hidden = true;
    noteModal.classList.remove('is-open');
    noteModal.style.display = 'none';
    document.body.classList.remove('om-note-open');
  }

  async function saveNoteAndCheckout(){
    // Re-check here too: the modal may have been opened before the cutoff.
    if (isClosed()) {
      hideNoteModal();
      applyClosedState();
      showClosedPopup();
      return;
    }
    const note = noteInput ? noteInput.value.trim() : '';
    try {
      await fetch('/cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        credentials:'same-origin',
        body: JSON.stringify({ note })
      });
    } catch(e){ console.warn('note save failed', e); }
    window.location.href = '/checkout';
  }

  // Ensure modal starts hidden
  if (noteModal) {
    noteModal.hidden = true;
    noteModal.classList.remove('is-open');
    noteModal.style.display = 'none';
    document.body.classList.remove('om-note-open');
  }

  applyClosedState();
  setInterval(applyClosedState, 30 * 1000);
  window.addEventListener('pageshow', applyClosedState);
  document.addEventListener('visibilitychange', ()=>{ if (!document.hidden) applyClosedState(); });

  on(checkoutBtn, 'click', (e)=>{ e.preventDefault(); showNoteModal(); });
  on(noteCancel, 'click', (e)=>{ e.preventDefault(); hideNoteModal(); });
  on(noteSubmit, 'click', (e)=>{ e.preventDefault(); saveNoteAndCheckout(); });
  on(noteModal, 'click', (e)=>{ if (e.target === noteModal) hideNoteModal(); });
  on(noteInput, 'keydown', (e)=>{ if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); saveNoteAndCheckout(); } });
  document.addEventListener('keydown', (e)=>{ if (e.key === 'Escape') hideNoteModal(); }, { passive: true });

  if (menu) bindCards(menu);
})(); 